











import Vue from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { mapGetters } from 'vuex';

interface Data {}

interface Methods {
  outsideClick: (e: Event) => void;
}

interface Computed {
  currentReminderLink: string;
}

interface Props {
  close: () => void | null;
}

export default Vue.extend({
  name: 'ReminderModal',
  props: {
    close: null,
  },
  methods: {
    outsideClick(e: MouseEvent) {
      if (!this.$refs.modal || (this.$refs.modal as HTMLElement).contains(e.target as HTMLElement)) {
        return;
      }
      this.close();
    },
  },
  computed: {
    ...mapGetters(['currentReminderLink']),
  },
  mounted() {
    document.addEventListener('mousedown', this.outsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.outsideClick);
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
